import React from 'react';

const SidebarFooter = ({ toggle, isOpen }) => {
  const iconCls = isOpen ? 'icon-arrow-left22' : 'icon-arrow-right22';
  let buttonCls = 'button clear sidebarBtn';
  if (isOpen) {
    buttonCls += ' pull-right';
  }
  return (
    <div className="sidebar-footer" onClick={toggle}>
      <button className={buttonCls}>
        <i className={iconCls} />
      </button>
    </div>
  );
};

export default SidebarFooter;
